import ClearIcon from "@mui/icons-material/Clear";
import {
	Autocomplete,
	Box,
	CircularProgress,
	debounce,
	TextField,
} from "@mui/material";
import { useCallback, useState } from "react";
import { UseFormRegister } from "react-hook-form";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import type { IB2B_list } from "./type/b2bType";
// Define the Country type

const B2BSelectFieldList = ({
	register,
	fieldName,
	label,
	hideCustomLabel,
	isRequired,
	mt,
	onChange,
	defaultValue,
}: {
	register?: UseFormRegister<any>;
	fieldName: string;
	label?: string;
	hideCustomLabel?: boolean;
	isRequired?: boolean;
	mt?: "0";
	onChange?: (e: number) => void;
	defaultValue?: {
		country_id: number;
		country_name: string;
	};
}) => {
	const [search, setSearch] = useState("");
	const { data, isLoading } = useGetQueryWithTotal<IB2B_list[]>({
		endPoint: "/api/fair/admin/b2b",
		queryKeys: ["B2B"],
		params: {
			name: search,
		},
	});

	const handleSearch = useCallback(
		debounce((value) => {
			setSearch(value);
		}, 300),
		[]
	);

	return (
		<Box sx={{ mt: mt ? 0 : 2 }}>
			{!hideCustomLabel && (
				<label>
					{label}{" "}
					{isRequired && <span style={{ color: "red" }}>*</span>}
				</label>
			)}

			<Autocomplete
				//defaultValue={{ visitor_id: 69, user_fair_member_company_name:''} || null}
				options={data?.data || []}
				getOptionLabel={(option: IB2B_list) =>
					option?.b2b_first_name + " " + option.b2b_last_name
				}
				// onInputChange={debounce((_, value) => {
				// 	setSearch(value);
				// }, 300)}
				onChange={(_, value: IB2B_list) => {
					register &&
						register(fieldName).onChange({
							target: {
								name: fieldName,
								value: value ? value.b2b_id : "",
							},
						});
					if (value?.b2b_id) {
						onChange && onChange(value?.b2b_id);
					}
				}}
				isOptionEqualToValue={(option, value) =>
					option?.b2b_id === value?.b2b_id
				}
				loading={isLoading}
				clearIcon={
					<span
						onClick={() => {
							setSearch("");
						}}
					>
						<ClearIcon fontSize='small' />
					</span>
				}
				renderInput={(params) => (
					<TextField
						{...params}
						placeholder='Enter B2B'
						required={isRequired}
						label={hideCustomLabel ? label : ""}
						variant='outlined'
						onChange={(value) => handleSearch(value?.target?.value)}
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<>
									{isLoading ? (
										<CircularProgress
											color='inherit'
											size={20}
										/>
									) : null}
									{params.InputProps.endAdornment}
								</>
							),
						}}
					/>
				)}
			/>
		</Box>
	);
};

export default B2BSelectFieldList;
